import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './VideoSection.css';

const VideoSection = () => {
  const { t } = useTranslation();
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlay = () => {
    if (videoRef.current) {
      videoRef.current.play();
      setIsPlaying(true);
    }
  };

  return (
    <section className="video-section">
      <div className="container">
        <div className="video-content">
          <h2 className="video-title" data-aos="fade-up">
            {t('video.title')}
          </h2>
          <div className="video-container" data-aos="fade-up" data-aos-delay="200">
            {!isPlaying && (
              <div className="video-thumbnail" onClick={handlePlay} role="button" aria-label="Reproduzir vídeo" tabIndex={0}>
                <picture>
                  <source type="image/webp" srcSet="/images/vd_capa.webp" />
                  <img src="/images/vd_capa.png" alt="Capa do vídeo" />
                </picture>
                <div className="play-button">
                  <span className="play-icon">▶</span>
                </div>
              </div>
            )}
            <video ref={videoRef} controls style={{ display: isPlaying ? 'block' : 'none' }}>
              <source src="/images/vd.mp4" type="video/mp4" />
              Seu navegador não suporta o elemento de vídeo.
            </video>
          </div>
          <p className="video-description" data-aos="fade-up" data-aos-delay="400">
            {t('video.description')}
          </p>
          <button className="btn btn-secondary" data-aos="fade-up" data-aos-delay="600">
            {t('video.button')}
          </button>
        </div>
      </div>
    </section>
  );
};

export default VideoSection;


